import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

var numeral = require("numeral");

Vue.prototype.$formatCurrency = value => {
    return numeral(value)
        .format("0,0")
        .replace(/,/g, ".");
};

Vue.prototype.$formatDate = value => {
    return moment(value).format("DD-MM-YYYY");
};

Vue.prototype.$formatNumber = value => {
    return numeral(value).format("0,0.0");
};

import OwlCarousel from 'v-owl-carousel'
Vue.component('carousel', OwlCarousel);

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select-c', vSelect);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

import ProjectSingle from "../pages/proyectos/ProjectSingle.vue";
import modalPromotions from "../pages/ModalPromotions.vue";

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (document.getElementById("vue-index")) {
    new Vue({
        el: '#vue-index',
        components: {
            ProjectSingle,
            modalPromotions
        },
        data: () => ({
            src_map: "",
            project: {
                medias: [],
                projectcontactsquery: [],
            },
            floor_medias: [],
            models: [],
            showModalPromotions: false
        }),
        methods: {
            openModal() {
                this.showModalPromotions = true;
            },
            closeModal() {
                this.showModalPromotions = false;
            }
        },
        vuetify: new Vuetify(),
    });
}

const positionInitial = {
    first: true,
    rect: null,
    scrollY: 0,
    initialVisible: false,
    value: null
};

window.addEventListener('scroll', function () {
    const sidebar = document.getElementById('form-contact-quotation');
    if (sidebar.offsetParent === null) {
        return;
    }
    const footerTop = document.getElementById('vue-footer').offsetTop;
    const divFormulario = sidebar.parentElement.parentElement;
    const divLogo = document.getElementById('form-contact-quotation');
    const wDivLogo = divLogo.offsetWidth

    const rect = divFormulario.getBoundingClientRect();
    const completelyVisible = rect.top >= 0 && rect.bottom + 20 <= window.innerHeight;

    if (completelyVisible && positionInitial.first === true) {
        positionInitial.initialVisible = true;
    }

    if (positionInitial.first === true) {
        positionInitial.rect = divFormulario.getBoundingClientRect();
        positionInitial.first = false;
        positionInitial.scrollY = window.scrollY;
    }

    if (window.scrollY + window.innerHeight > footerTop) {
        positionInitial.value = 'tope abajo';
        divFormulario.style.position = 'absolute';
        divFormulario.style.bottom = '40px';
    } else if (this.window.scrollY + rect.top < positionInitial.rect.top) {
        positionInitial.value = 'tope arriba';
        divFormulario.style.position = 'initial';
    } else if (completelyVisible) {
        positionInitial.value = 'fijar';
        divFormulario.style.position = 'fixed';
        divFormulario.style.bottom = positionInitial.initialVisible ? 'auto' : '20px';
        divFormulario.style.width = wDivLogo + 'px';
    } else if (positionInitial.value === 'tope abajo') {
        positionInitial.value = 'fijar';
        divFormulario.style.position = 'fixed';
        divFormulario.style.bottom = positionInitial.initialVisible ? 'auto' : '20px';
        divFormulario.style.width = wDivLogo + 'px';

    }
});